var $3351817a04898858$exports = {};
$3351817a04898858$exports = {
  "rangeOverflow": function rangeOverflow(args) {
    return "Az \xE9rt\xE9knek ".concat(args.maxValue, " vagy kor\xE1bbinak kell lennie.");
  },
  "rangeReversed": "A kezd\u0151 d\xE1tumnak a befejez\u0151 d\xE1tumn\xE1l kor\xE1bbinak kell lennie.",
  "rangeUnderflow": function rangeUnderflow(args) {
    return "Az \xE9rt\xE9knek ".concat(args.minValue, " vagy k\xE9s\u0151bbinek kell lennie.");
  },
  "unavailableDate": "A kiv\xE1lasztott d\xE1tum nem \xE9rhet\u0151 el."
};
export { $3351817a04898858$exports as default };